import { useContext } from "react";
import { StatusesContext } from "./StatusesContext";

export default () => {
    const context = useContext(StatusesContext);

    if (context === undefined) throw new Error("useVerificationStatus must be used within a VerificationStatusProvider");

    return context;
};
